import { pipe, prop } from 'ramda';

import type { PageConfig } from './landing-types';

const selectAllLandingState = prop('landing');

export const selectLandingSlug = pipe(
  selectAllLandingState,
  prop<string>('slug')
);

export const selectLandingPage = pipe(selectAllLandingState, prop('page'));

export const selectLandingPageData = pipe(
  selectLandingPage,
  prop<PageConfig>('data')
);

export const selectLandingPageIsDataLoading = pipe(
  selectLandingPage,
  prop<boolean>('isLoading')
);
